"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var get_1 = __importDefault(require("./utilities/object/get"));
exports.get = get_1.default;
var set_1 = __importDefault(require("./utilities/object/set"));
exports.set = set_1.default;
var sort_1 = __importDefault(require("./utilities/object/sort"));
exports.sort = sort_1.default;
var clone_1 = __importDefault(require("./utilities/object/clone"));
exports.clone = clone_1.default;
var merge_1 = __importDefault(require("./utilities/object/merge"));
exports.merge = merge_1.default;
var only_1 = __importDefault(require("./utilities/object/only"));
exports.only = only_1.default;
/**
 * Object Class Handler
 *
 * @export
 * @class Obj
 */
var Obj = /** @class */ (function () {
    function Obj() {
    }
    /**
     * Set the given value to the given key
     * The key is a dot.notation syntax
     *
     * @param  {ObjectInterface} object
     * @param  {string} key
     * @param  {any} value
     * @returns {ObjectInterface}
     */
    Obj.set = function (object, key, value) {
        return set_1.default(object, key, value);
    };
    /**
     * Get the value of the given key
     *
     * @param  {ObjectInterface} object
     * @param  {string} key
     * @param  {any} $default
     * @returns any
     */
    Obj.get = function (object, key, $default) {
        if ($default === void 0) { $default = null; }
        return get_1.default(object, key, $default);
    };
    /**
     * Clone the given object to new one
     *
     * @param {ObjectInterface} object
     * @return {ObjectInterface}
     */
    Obj.clone = function (object) {
        return clone_1.default(object);
    };
    /**
     * Merge all given objects into one BIG object
     *
     * @param {any} objects
     * @return {ObjectInterface}
     */
    Obj.merge = function () {
        var objects = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            objects[_i] = arguments[_i];
        }
        return merge_1.default.apply(void 0, __spread(objects));
    };
    /**
     * Sort the given object by its keys
     *
     * @param   {ObjectInterface} object
     * @returns {ObjectInterface}
     */
    Obj.prototype.sort = function (object) {
        return sort_1.default(object);
    };
    /**
     * Get only the given keys from the given object
     *
     * @param   {ObjectInterface} object
     * @param   {array} keys
     * @returns {ObjectInterface}
     */
    Obj.prototype.only = function (object, keys) {
        return only_1.default(object, keys);
    };
    return Obj;
}());
exports.default = Obj;
//# sourceMappingURL=obj.js.map